import React from 'react';

interface WheelPointerProps {
  deflectionDeg?: number;
  isSpinning?: boolean;
}

export const WheelPointer: React.FC<WheelPointerProps> = ({
  deflectionDeg = 0,
  isSpinning = false,
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '-12px',
        left: '50%',
        zIndex: 20,
        pointerEvents: 'none',
        transformOrigin: '50% 15%',
        transform: `translateX(-50%) rotate(${deflectionDeg}deg)`,
        transition: isSpinning ? 'none' : 'transform 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        filter: isSpinning
          ? 'drop-shadow(0 4px 12px rgba(239, 68, 68, 0.8))'
          : 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))',
      }}
    >
      <svg
        width="44"
        height="54"
        viewBox="0 0 44 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="pointerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#ef4444" />
            <stop offset="60%" stop-color="#dc2626" />
            <stop offset="100%" stop-color="#991b1b" />
          </linearGradient>
          <linearGradient id="pointerRim" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#ffffff" stop-opacity="0.8" />
            <stop offset="100%" stop-color="#fee2e2" stop-opacity="0.2" />
          </linearGradient>
        </defs>

        {/* Pointer Base Pivot Ring */}
        <circle cx="22" cy="14" r="10" fill="#1e293b" stroke="#e2e8f0" strokeWidth="2.5" />
        <circle cx="22" cy="14" r="5" fill="#ef4444" />

        {/* Pointer Arrow Body Pointing Downward */}
        <path
          d="M14 16 L22 48 L30 16 Z"
          fill="url(#pointerGrad)"
          stroke="#fee2e2"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />

        {/* Highlight Bevel */}
        <path
          d="M22 16 L22 46"
          stroke="url(#pointerRim)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
